import { ACTIONS } from "./ActionTypes";
export const setItem = (key, value) => ({
  type: ACTIONS.SET_ITEM,
  payload: {
    key,
    value
  }
});
export const clearItem = key => ({
  type: ACTIONS.CLEAR_ITEM,
  payload: {
    key
  }
});
export const clearAll = () => ({
  type: ACTIONS.CLEAR_ALL
});